import { SsoType } from '@diritto/common/account/constants/sso.constant';
import { buildUrl } from '@diritto/common/utils/urls';
import { useAuthState } from 'contexts/AuthProvider';
import { DirittoAppBridge } from 'libs/DirittoAppBridge';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';
import { useClient } from 'ui-hooks/useClient';
import { useRequestSign } from 'ui-hooks/useRequestSign';

export const useRequestSsoLink = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const url = `${pathname}?${searchParams?.toString()}`;
  const { isApp } = useClient();
  const { isLoaded, isLoggedIn } = useAuthState();
  const requestSign = useRequestSign();

  return useCallback(
    (ssoType: SsoType) => {
      if (!isLoaded) {
        return;
      }

      if (!isLoggedIn) {
        requestSign();
        return;
      }

      const link = buildUrl('/accounts/link', {
        ssoType,
        returnUrl: url,
      });

      if (isApp) {
        DirittoAppBridge.openSignView(link);
        return;
      }
      router.push(link);
    },
    [url, isApp, isLoaded, isLoggedIn, requestSign, router],
  );
};
